export default __webpack_public_path__ + "static/2-2d410556fc72cb4493b34ad44d4ba609.jpeg";